import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Badge, Button, Row, Col } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LanguageProvider } from '../../core/language-provider';
import { LoginManager } from '../../core/login-manager';
import moment from 'moment';
import ImportXmlMetron from '../components/ImportXmlMetron';
import ImportXml3Cad from '../components/ImportXmlCad';
import { settings } from '../settings';
import { toast } from 'react-toastify';



export default function InstanceCompilerTopHook({ data, entity = null, setDataKeyValue }) {

    var userInfo = LoginManager.getUserInfo();
    var now = moment();
    var location = useLocation();


    useEffect(() => {
        console.log(location, data)
        if (entity == 'customer_order') {
            var rows = data.rows
            if (rows && rows.length > 0 && data.orderDate && data.orderDate !== null) {
                var maxDate = moment(data.orderDate)
                for (let i = 0; i < rows.length; i++) {
                    var r = rows[i]
                    if (r.idSupplier !== null) {
                        if (r.idSupplier.deliveryTime) {
                            var tempDate = moment(data.orderDate, "YYYY-MM-DD").add(r.idSupplier.deliveryTime, 'days').format("YYYY-MM-DD")
                            if (moment(tempDate) > maxDate) {
                                maxDate = moment(tempDate)
                            }
                        }
                    }
                }
                if (data.deliveryDate !== moment(maxDate).format("YYYY-MM-DD")) {
                    setDataKeyValue('deliveryDate', moment(maxDate).format("YYYY-MM-DD"))
                }
            }
        }
        if (entity === 'customer_offer') {
            console.warn(data)
            if (data.idCustomer && data.idCustomer !== null) {
                if (data.idPaymentCondition === "" && data.idPaymentCondition !== data.idCustomer.idPaymentCondition) {
                    setDataKeyValue('idPaymentCondition', data.idCustomer.idPaymentCondition)
                }
            }
            if (data.rows.length > 0) {

                var count = 0;
                for (let i = 0; i < data.rows.length; i++) {
                    if (data.rows[i].price !== "0") {
                        count++;
                    }
                    var totale = data.rows.reduce((acc, item) => {
                        return acc + (parseFloat(item.price))
                    }, 0)
                    var totaleIva = data.rows.reduce((acc, item) => {
                        return acc + (parseFloat(item.vatPrice))
                    }, 0)
                    var totalListPrice = data.rows.reduce((acc, item) => {
                        return acc + (parseFloat(item.listPrice) * item.quantity)
                    }, 0)
                }
                if (data.totalRows !== parseFloat(totale).toFixed(2)) {
                    setDataKeyValue('totalRows', totale.toFixed(2))
                }
                if (data.totalListPrice !== parseFloat(totalListPrice).toFixed(2)) {
                    setDataKeyValue('totalListPrice', totalListPrice.toFixed(2))
                }
                var totale1 = parseFloat(totale);
                var totaleIVA = parseFloat(totaleIva);


                if (settings.iva_esclusa) {
                    totale1 = totale1 + totaleIVA;
                }



                if (data.totalPrice !== totale1.toFixed(2)) {
                    setDataKeyValue('totalPrice', totale1.toFixed(2))
                }
                if (data.totalVat !== totaleIVA.toFixed(2)) {
                    setDataKeyValue('totalVat', totaleIVA.toFixed(2))
                }

                //calcolo del totale sconti
                var totalDiscounts = data.rows.map((item) => {
                    var t = (parseFloat(item.listPrice) * (parseFloat(item.discountPercentage) / 100)) + (parseFloat(item.listPrice) * (parseFloat(item.discountOffer) / 100)) + (parseFloat(item.discount));
                    return Number(t.toFixed(2))
                })

                totalDiscounts = totalDiscounts.reduce((acc, num) => acc + parseFloat(num), 0);

                if (data.totalDiscount !== totalDiscounts) {
                    setDataKeyValue('totalDiscount', totalDiscounts)
                }

            }
        }
        if (entity === 'customer_order') {
            console.warn(data)
            if (data.idCustomer && data.idCustomer !== null) {
                if (data.idPaymentCondition === "" && data.idPaymentCondition !== data.idCustomer.idPaymentCondition) {
                    setDataKeyValue('idPaymentCondition', data.idCustomer.idPaymentCondition)
                }
                if (data.deliveryAddress === "" && data.deliveryAddress !== data.idCustomer.address) {
                    setDataKeyValue('deliveryAddress', data.idCustomer.address);
                    setDataKeyValue('latitude', data.idCustomer.latitude);
                    setDataKeyValue('longitude', data.idCustomer.longitude);
                }
            }
            if (data.rows.length > 0) {
                var count = 0;
                for (let i = 0; i < data.rows.length; i++) {
                    if (data.rows[i].price !== "0") {
                        count++;
                    }
                    var totale = data.rows.reduce((acc, item) => {
                        return acc + (parseFloat(item.price))
                    }, 0)
                    var totaleIva = data.rows.reduce((acc, item) => {
                        return acc + (parseFloat(item.vatPrice))
                    }, 0)
                    var totalListPrice = data.rows.reduce((acc, item) => {
                        return acc + (parseFloat(item.listPrice) * item.quantity)
                    }, 0)
                }
                if (data.totalRows !== parseFloat(totale).toFixed(2)) {
                    setDataKeyValue('totalRows', totale.toFixed(2))
                }
                if (data.totalListPrice !== parseFloat(totalListPrice).toFixed(2)) {
                    setDataKeyValue('totalListPrice', totalListPrice.toFixed(2))
                }
                var totale1 = parseFloat(totale);
                var totaleIVA = parseFloat(totaleIva);

                if (settings.iva_esclusa) {
                    totale1 = totale1 + totaleIVA;
                }

                if (data.totalPrice !== totale1.toFixed(2)) {
                    setDataKeyValue('totalPrice', totale1.toFixed(2))
                }
                if (data.totalVat !== totaleIVA.toFixed(2)) {
                    setDataKeyValue('totalVat', totaleIVA.toFixed(2))
                }


                //calcolo del totale sconti
                var totalDiscounts = data.rows.map((item) => {
                    var t = parseFloat(item.listPrice) * (parseFloat(item.discountPercentage) / 100) + parseFloat(item.listPrice) * (parseFloat(item.discountOrder) / 100) + parseFloat(item.discount);
                    return Number(t.toFixed(2))
                })

                console.log(totalDiscounts)
                var totalDiscounts1 = totalDiscounts.reduce((acc, num) => acc + num, 0);


                if (data.totalDiscount !== parseFloat(totalDiscounts1).toFixed(2)) {
                    setDataKeyValue('totalDiscount', parseFloat(totalDiscounts1).toFixed(2))
                }
            }
        }
        if (entity === 'supplier_order') {
            if (data.idSupplier && data.idSupplier !== null) {
                if (data.idPaymentCondition !== data.idSupplier.idPaymentCondition) {
                    setDataKeyValue('idPaymentCondition', data.idSupplier.idPaymentCondition)
                }
            }
            if (data.file && data.file !== null) {
                var field = document.getElementById("supplier_order_field_confirmedDeliveryDate").querySelector("input");
                field.required = true
            }
            if (data.idCustomerOrder && data.idCustomerOrder !== null && data.idCustomerOrder.idCustomer) {
                if (data.customerName !== data.idCustomerOrder.idCustomer.name) {
                    setDataKeyValue('customerName', data.idCustomerOrder.idCustomer.name)
                }
            }
            if (location.pathname === '/entity/supplier_order/edit') {
                var field = document.getElementById("supplier_order_field_rows");
                if (field) {
                    field.remove()
                }
            }
        }
        if (entity === 'customer_offer_row') {
            console.warn(data)
            if (!settings.sconti) {
                if (data.discount !== "0") {
                    document.querySelector('#customer_offer_row_field_discount input').disabled = true;
                    setDataKeyValue('discount', "0")
                }
                if (data.discountPercentage !== "0") {
                    document.querySelector('#customer_offer_row_field_discountPercentage input').disabled = true;
                    setDataKeyValue('discountPercentage', "0")
                }
            }
            if (data.idSupplier !== "") {
                console.log(data.discountPercentage, data.idSupplier.sale_discount)
                if (data.discountPercentage === "0" && data.discountPercentage !== data.idSupplier.sale_discount) {
                    setDataKeyValue('discountPercentage', data.idSupplier.sale_discount)
                }
            }
            var fieldDiscount = document.querySelector("#customer_offer_field_discount input");
            if (data.discountOffer && fieldDiscount && fieldDiscount.value !== "0") {
                if (data.discountOffer !== fieldDiscount.value) {
                    setDataKeyValue('discountOffer', fieldDiscount.value)
                }
            }
            var fieldIVA = document.querySelector("#customer_offer_field_vat input");
            if (data.vat && data.vat === "") {
                if (data.vat !== fieldIVA.value) {
                    setDataKeyValue('vat', fieldIVA.value)
                }
            }
            if (data.listPrice) {
                var t = parseFloat(data.listPrice) * parseFloat(data.quantity);
                if (data.discountOffer !== "") {
                    var t1 = ((t * 1) * (data.discountOffer * 1) / 100)
                    console.log(t)
                }
                if (data.discountPercentage !== "") {
                    var t2 = ((t * 1) * (data.discountPercentage * 1) / 100)
                    console.log(t)
                }
                if (data.discount !== "") {
                    var t3 = parseFloat(data.discount)
                    console.log(t)
                }
                t = t - t1 - t2 - t3;
                t = parseFloat(t).toFixed(2)
                console.log(t)
                if (data.price !== t) {
                    setDataKeyValue('price', t)
                }
                if (data.price !== "0" && data.vat !== "") {
                    if (settings.iva_esclusa) {
                        console.log((parseFloat(data.vat) / 100) * parseFloat(data.price))
                        var a = (parseFloat(data.vat) / 100) * parseFloat(data.price)
                        var b = a + parseFloat(data.price)
                        if (data.vatPrice !== a) {
                            setDataKeyValue('vatPrice', a)
                        }
                        if (data.totalPrice !== b) {
                            setDataKeyValue('totalPrice', b)
                        }
                    } else {
                        var a = parseFloat(data.price) * ((parseFloat(data.vat) / 100) / (1 + (parseFloat(data.vat) / 100)))
                        a = parseFloat(a).toFixed(2)
                        if (data.vatPrice !== a) {
                            setDataKeyValue('vatPrice', a)
                        }
                        if (data.totalPrice !== t) {
                            setDataKeyValue('totalPrice', t)
                        }

                    }
                }

            }
            if (data.idCategory !== "" && data.description === "") {
                if (data.idCategory && (data.idCategory.description !== "" && data.idCategory.description !== null)) {
                    setDataKeyValue('description', data.idCategory.description)
                }
            }
            if(data.listPrice === "" || data.price === ""){
                toast.warning("Attenzione! I campi prezzo non possono essere vuoti, inserire 0.", {theme: 'colored'})
            }

        }
        if (entity === 'customer_order_row') {
            if (!settings.sconti) {
                if (data.discount !== "0") {
                    document.querySelector('#customer_order_row_field_discount input').disabled = true;
                    setDataKeyValue('discount', "0")
                }
                if (data.discountPercentage !== "0") {
                    document.querySelector('#customer_order_row_field_discountPercentage input').disabled = true;
                    setDataKeyValue('discountPercentage', "0")
                }
            }
            console.warn(data)
            if (data.idSupplier !== "") {
                console.log(data.discountPercentage, data.idSupplier.sale_discount)
                if (data.discountPercentage === "0" && data.discountPercentage !== data.idSupplier.sale_discount) {
                    setDataKeyValue('discountPercentage', data.idSupplier.sale_discount)
                }
            }
            var fieldDiscount = document.querySelector("#customer_order_field_discount input");
            if (data.discountOrder && fieldDiscount && fieldDiscount.value !== "0") {
                if (data.discountOrder !== fieldDiscount.value) {
                    setDataKeyValue('discountOrder', fieldDiscount.value)
                }
            }
            var fieldIVA = document.querySelector("#customer_order_field_vat input");
            if (data.vat === "") {
                if (data.vat !== fieldIVA.value) {
                    setDataKeyValue('vat', fieldIVA.value)
                }
            }
            if (data.listPrice) {
                var t = parseFloat(data.listPrice) * parseFloat(data.quantity);
                if (data.discountOrder !== "") {
                    var t1 = ((t * 1) * (data.discountOrder * 1) / 100)
                }
                if (data.discountPercentage !== "") {
                    var t2 = ((t * 1) * (data.discountPercentage * 1) / 100)
                }
                if (data.discount !== "") {
                    var t3 = parseFloat(data.discount)
                }
                t = t - t1 - t2 - t3;
                if (data.price !== t) {
                    setDataKeyValue('price', t)
                }
                if (data.price !== "0" && data.vat !== "") {
                    if (settings.iva_esclusa) {
                        console.log((parseFloat(data.vat) / 100) * parseFloat(data.price))
                        var a = (parseFloat(data.vat) / 100) * parseFloat(data.price)
                        var b = a + parseFloat(data.price)
                        if (data.vatPrice !== a) {
                            setDataKeyValue('vatPrice', a)
                        }
                        if (data.totalPrice !== b) {
                            setDataKeyValue('totalPrice', b)
                        }
                    } else {
                        var a = parseFloat(data.price) * ((parseFloat(data.vat) / 100) / (1 + (parseFloat(data.vat) / 100)))
                        a = parseFloat(a).toFixed(2)
                        if (data.vatPrice !== a) {
                            setDataKeyValue('vatPrice', a)
                        }
                        if (data.totalPrice !== t) {
                            setDataKeyValue('totalPrice', t)
                        }

                    }
                }
            }
            if (data.idCategory !== "" && data.description === "") {
                if (data.idCategory && (data.idCategory.description !== "" && data.idCategory.description !== null)) {
                    setDataKeyValue('description', data.idCategory.description)
                }
            }
            if(data.listPrice === "" || data.price === ""){
                toast.warning("Attenzione! I campi prezzo non possono essere vuoti, inserire 0.", {theme: 'colored'})
            }

        }
        if (entity === 'notification') {

            console.warn(data)
            if (data.notificationAll === 0) {
                if (data.notificationOrder !== 0) {
                    setDataKeyValue('notificationOrder', 0);

                }
                if (data.notificationOffer !== 0) {
                    setDataKeyValue('notificationOffer', 0);

                }
            }


        }
        if (entity === 'customer_order_payment') {
            console.warn(data)
            if (data.paymentDate === "") {
                var today = now.format('YYYY-MM-DD');
                if (data.paymentDate !== today) {
                    setDataKeyValue('paymentDate', today);
                }
            }
            if (data.idCustomerOrder && data.idCustomerOrder !== "") {
                if (data.idCustomerOrder && data.idCustomerOrder.idCustomer) {
                    if (data.idCustomer !== data.idCustomerOrder.idCustomer) {
                        setDataKeyValue('idCustomer', data.idCustomerOrder.idCustomer)
                    }
                }
            }
        }

    }, [data]);


    useEffect(() => {
        if (entity === 'customer_offer') {
            if (data.rows.length > 0) {
                var clone = data.rows.map(obj => ({
                    ...obj,
                    discountOffer: data.discount,
                    price: (parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount),
                    vatPrice: settings.iva_esclusa ? (((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount)) * (parseFloat(obj.vat) / 100)) : (((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount)) * (parseFloat(obj.vat) / 100) / (1 + (parseFloat(obj.vat) / 100))),
                    totalPrice: settings.iva_esclusa ? ((((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount)) * (parseFloat(obj.vat) / 100)) + ((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount))) : ((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount))

                }))
                console.log(clone)
                setDataKeyValue('rows', clone)
            }
        }
        if (entity === 'customer_order') {
            if (data.rows.length > 0) {
                var clone = data.rows.map(obj => ({
                    ...obj,
                    discountOrder: data.discount,
                    price: (parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount),
                    vatPrice: settings.iva_esclusa ? (((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount)) * (parseFloat(obj.vat) / 100)) : (((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount)) * (parseFloat(obj.vat) / 100) / (1 + (parseFloat(obj.vat) / 100))),
                    totalPrice: settings.iva_esclusa ? ((((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount)) * (parseFloat(obj.vat) / 100)) + ((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount))) : ((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount))

                }))
                console.log(clone)
                setDataKeyValue('rows', clone)
            }
        }
    }, [data.discount])




    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'sample': return (
                            <span>Test</span>
                        );
                        case 'customer_order': return (
                            <>
                                {location && location.pathname === "/entity/customer_order/edit" ? <><Container>
                                    <Row className='w-full'>
                                        <Col className='p-0'>
                                            Codice interno ordine: {data.internalCode}
                                        </Col>
                                    </Row>
                                </Container></> : null}

                                <Container fluid className='text-end mb-2'>

                                    <ImportXmlMetron data={data} entity='customer_order' setDataKeyValue={setDataKeyValue} />
                                    <ImportXml3Cad data={data} entity='customer_order' setDataKeyValue={setDataKeyValue} />
                                </Container>
                            </>

                        );
                        case 'customer_offer': return (
                            <>
                                {location && location.pathname === "/entity/customer_offer/edit" ? <><Container>
                                    <Row className='w-full'>
                                        <Col className='p-0'>
                                            Codice interno preventivo: {data.internalCode}
                                        </Col>
                                    </Row>
                                </Container></> : null}
                                <Container fluid className='text-end mb-2'>
                                    <ImportXmlMetron data={data} entity='customer_offer' setDataKeyValue={setDataKeyValue} />
                                    <ImportXml3Cad data={data} entity='customer_offer' setDataKeyValue={setDataKeyValue} />
                                </Container>
                            </>

                        );
                        case 'supplier_order': return (
                            <>
                                {location && location.pathname === "/entity/supplier_order/edit" ? <><Container>
                                    <Row className='w-full'>
                                        <Col className='p-0'>
                                            Codice interno ordine fornitore: {data.internalCode}
                                        </Col>
                                    </Row>
                                </Container></> : null}
                            </>

                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};